import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { GetLocalStorage } from "../Helpers/LocalStorage/LocalStorage"; 
import { BaseUrl } from "../Actions/Base"; 

export function useAppSocket(UserInfo) {
  const [socket, setSocket] = useState(null);

  // const tokenId = GetLocalStorage("UserInfo")?.UserId;
  // const userType = GetLocalStorage("UserInfo")?.User;
  // const instituteUserType = GetLocalStorage("UserInfo")?.InstituteUserType;

  useEffect(() => {
    if (!UserInfo?.UserId) return;

    // if (!tokenId) return;

    const tokenId = UserInfo?.UserId;
    const userType = UserInfo?.User;
    const instituteUserType = UserInfo?.InstituteUserType;

    let url = BaseUrl;

    if (userType === "Admin") {
      url += "/vliadmin"; // ← add this case specifically
    } else if (userType === "Institute") {
      url += `/${userType.toLowerCase()}/${instituteUserType?.toLowerCase()}`;
    } else if (userType && userType !== "Student") {
      url += `/${userType.toLowerCase()}`;
    }

    const socketInstance = io(url, {
      auth: { token: tokenId },
    });

    setSocket(socketInstance);

    return () => socketInstance.disconnect();
  }, [UserInfo]);

  return socket;
}
